import React from 'react';
import Modal from '@material-ui/core/Modal';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";

type ModalProps = {
  classes?: any,
}

class Loader extends React.Component<ModalProps, any> {
  state = {
    open: true
  };

  //PM 2021-09-01
  //aktualizacja z zaktualizowana wersja react-scripts
  render() {
    const classes = this.props.classes;

    return (
      <Modal
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        open={true}

      >
        <div style={{ position: 'absolute' }} className={classes.alert}>
          <img src={require('./loader.gif').default} ></img>
        </div>
      </Modal>
    );
  }
}

const styles = (theme: Theme) => ({
  alert: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    //background : '#ffffff',
    padding: theme.spacing(2, 4, 3),
    outline: 0
  }
});

export default withStyles(styles)(Loader);